import type {
  AdminId,
  AdminInviteId,
  AllowedDomainId,
  BrandId,
  CallPushId,
  CoinPackId,
  DefaultLookId,
  DeviceId,
  FriendCode,
  GlobalNgWordId,
  HomeBannerId,
  HomeLivePinId,
  HomePickupId,
  InviteKey,
  ItemDistributionId,
  ItemId,
  LiveCommentId,
  LiveCountId,
  LiveFreeBoardId,
  LiveGenreId,
  LiveId,
  LivePowerId,
  LiveReactionId,
  ManagedImageId,
  PinnedStoryUserId,
  PowerId,
  PredefinedAliasId,
  PredefinedAliasQualifierId,
  PredefinedNicknameId,
  PushDeviceName,
  SaleId,
  SelectionId,
  SoulId,
  SelectionParticipantId,
  SelectionSequenceId,
  SpaceBackgroundId,
  SpaceBGMId,
  SpaceKey,
  SpaceMessageId,
  StampCardId,
  StampLaneId,
  StampLaneRewardId,
  StampMissionId,
  StoryId,
  SubscriptionHistoryId,
  SubscriptionId,
  SubscriptionItemGrantMasterId,
  SubscriptionPlanId,
  SubscriptionProductId,
  SystemNotificationId,
  TaskId,
  TaskResultId,
  TopicSuggestionId,
  UserId,
  UserVrmRegistrationId,
  ViolationReportId,
  VoiceEmoteId,
  VoiceId,
  VoiceReplyEmoteId,
  VoiceReplyId,
  WelcomeDeliveryMasterId,
  AdminOperationId,
  LivePointId,
} from "./id"

export const FirestorePaths = {
  Users: {
    path: "users",
    getDocPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}`,

    BlockUsers: {
      path: "block-users",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.BlockUsers.path}`,
      getDocPath: (userId: UserId, blockedUserId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.BlockUsers.path}/${blockedUserId}`,
    },
    Followers: {
      path: "followers",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Followers.path}`,
      getDocPath: (userId: UserId, followerId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Followers.path}/${followerId}`,
    },
    PushDevices: {
      path: "push-devices",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.PushDevices.path}`,
      getDocPath: (userId: UserId, deviceName: PushDeviceName): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.PushDevices.path}/${deviceName}`,
    },
    SystemNotificationReadStatuses: {
      path: "system-notification-read-statuses",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.SystemNotificationReadStatuses.path}`,
      getDocPath: (userId: UserId, notificationId: SystemNotificationId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.SystemNotificationReadStatuses.path}/${notificationId}`,
    },
    UserSpaceSetting: {
      path: "user-space-setting",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.UserSpaceSetting.path}`,
      getDocPath: (userId: UserId, spaceKey: SpaceKey): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.UserSpaceSetting.path}/${spaceKey}`,
    },
    PersonalNotifications: {
      path: "personal-notifications",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.PersonalNotifications.path}`,
      getDocPath: (userId: UserId, notificationId: string): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.PersonalNotifications.path}/${notificationId}`,
    },
    Stories: {
      path: "stories",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Stories.path}`,
      getDocPath: (userId: UserId, storyId: StoryId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Stories.path}/${storyId}`,
    },
    Voices: {
      path: "voices",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}`,
      getDocPath: (userId: UserId, voiceId: VoiceId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}/${voiceId}`,

      VoiceReplies: {
        path: "voice-replies",
        getPath: (userId: UserId, voiceId: VoiceId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}/${voiceId}/${FirestorePaths.Users.Voices.VoiceReplies.path}`,
        getDocPath: (userId: UserId, voiceId: VoiceId, replyId: VoiceReplyId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}/${voiceId}/${FirestorePaths.Users.Voices.VoiceReplies.path}/${replyId}`,

        VoiceReplyEmotes: {
          path: "voice-reply-emotes",
          getPath: (userId: UserId, voiceId: VoiceId, replyId: VoiceReplyId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}/${voiceId}/${FirestorePaths.Users.Voices.VoiceReplies.path}/${replyId}/${FirestorePaths.Users.Voices.VoiceReplies.VoiceReplyEmotes.path}`,
          getDocPath: (userId: UserId, voiceId: VoiceId, replyId: VoiceReplyId, emoteId: VoiceReplyEmoteId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}/${voiceId}/${FirestorePaths.Users.Voices.VoiceReplies.path}/${replyId}/${FirestorePaths.Users.Voices.VoiceReplies.VoiceReplyEmotes.path}/${emoteId}`,
        },
      },
      VoiceEmotes: {
        path: "voice-emotes",
        getPath: (userId: UserId, voiceId: VoiceId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}/${voiceId}/${FirestorePaths.Users.Voices.VoiceEmotes.path}`,
        getDocPath: (userId: UserId, voiceId: VoiceId, emoteId: VoiceEmoteId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.Voices.path}/${voiceId}/${FirestorePaths.Users.Voices.VoiceEmotes.path}/${emoteId}`,
      },
    },
    VrmRegistrations: {
      path: "vrm-registrations",
      getPath: (userId: UserId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.VrmRegistrations.path}`,
      getDocPath: (userId: UserId, registrationId: UserVrmRegistrationId): string => `${FirestorePaths.Users.path}/${userId}/${FirestorePaths.Users.VrmRegistrations.path}/${registrationId}`,
    },
  },
  Spaces: {
    path: "spaces",
    getDocPath: (spaceKey: SpaceKey): string => `${FirestorePaths.Spaces.path}/${spaceKey}`,

    SpaceUsers: {
      path: "space-users",
      getPath: (spaceKey: SpaceKey): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.SpaceUsers.path}`,
      getDocPath: (spaceKey: SpaceKey, userId: UserId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.SpaceUsers.path}/${userId}`,
    },
    SpaceMessages: {
      path: "space-messages",
      getPath: (spaceKey: SpaceKey): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.SpaceMessages.path}`,
      getDocPath: (spaceKey: SpaceKey, messageId: SpaceMessageId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.SpaceMessages.path}/${messageId}`,
    },
    SpaceMessageDeletions: {
      path: "space-message-deletions",
      getPath: (spaceKey: SpaceKey): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.SpaceMessageDeletions.path}`,
      getDocPath: (spaceKey: SpaceKey, messageId: SpaceMessageId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.SpaceMessageDeletions.path}/${messageId}`,
    },
    HiddenViewers: {
      path: "hidden-viewers",
      getPath: (spaceKey: SpaceKey): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.HiddenViewers.path}`,
      getDocPath: (spaceKey: SpaceKey, userId: UserId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.HiddenViewers.path}/${userId}`,
    },
    Lives: {
      path: "lives",
      getPath: (spaceKey: SpaceKey): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}`,
      getDocPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}`,

      LiveComments: {
        path: "comments",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveComments.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, commentId: LiveCommentId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveComments.path}/${commentId}`,
      },
      LiveCommentDeletions: {
        path: "live-comment-deletions",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveCommentDeletions.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, commentId: LiveCommentId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveCommentDeletions.path}/${commentId}`,
      },
      LiveReactions: {
        path: "live-reactions",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveReactions.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, reactionId: LiveReactionId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveReactions.path}/${reactionId}`,
      },
      LiveFreeBoards: {
        path: "live-free-boards",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveFreeBoards.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, freeBoardId: LiveFreeBoardId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveFreeBoards.path}/${freeBoardId}`,
      },
      LiveViewers: {
        path: "live-viewers",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveViewers.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, userId: UserId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveViewers.path}/${userId}`,

        LiveViewLogs: {
          path: "live-view-logs",
          getPath: (spaceKey: SpaceKey, liveId: LiveId, userId: UserId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveViewers.path}/${userId}/${FirestorePaths.Spaces.Lives.LiveViewers.LiveViewLogs.path}`,
          getDocPath: (spaceKey: SpaceKey, liveId: LiveId, userId: UserId, logId: string): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveViewers.path}/${userId}/${FirestorePaths.Spaces.Lives.LiveViewers.LiveViewLogs.path}/${logId}`,
        },
      },
      LiveCounts: {
        path: "live-counts",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveCounts.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, countId: LiveCountId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveCounts.path}/${countId}`,
      },
      LivePowers: {
        path: "live-powers",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LivePowers.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, powerId: LivePowerId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LivePowers.path}/${powerId}`,
      },
      PowerCountShards: {
        path: "power-count-shards",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.PowerCountShards.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, shardId: string): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.PowerCountShards.path}/${shardId}`,
      },
      LiveEvents: {
        path: "live-events",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveEvents.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, eventId: string): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LiveEvents.path}/${eventId}`,
      },
      LivePowerSummaries: {
        path: "live-power-summaries",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LivePowerSummaries.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, userId: UserId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.LivePowerSummaries.path}/${userId}`,
      },
      Selections: {
        path: "selections",
        getPath: (spaceKey: SpaceKey, liveId: LiveId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}`,
        getDocPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}`,

        SelectionParticipants: {
          path: "participants",
          getPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionParticipants.path}`,
          getDocPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, participantId: SelectionParticipantId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionParticipants.path}/${participantId}`,
        },
        SelectionPseudoNominates: {
          path: "pseudo-nominates",
          getPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionPseudoNominates.path}`,
          getDocPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, nominateId: SelectionParticipantId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionPseudoNominates.path}/${nominateId}`,
        },
        SelectionSequences: {
          path: "sequences",
          getPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionSequences.path}`,
          getDocPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, sequenceId: SelectionSequenceId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionSequences.path}/${sequenceId}`,
        },
        SelectionNominates: {
          path: "nominates",
          getPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionNominates.path}`,
          getDocPath: (spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, nominateId: SelectionParticipantId): string => `${FirestorePaths.Spaces.path}/${spaceKey}/${FirestorePaths.Spaces.Lives.path}/${liveId}/${FirestorePaths.Spaces.Lives.Selections.path}/${selectionId}/${FirestorePaths.Spaces.Lives.Selections.SelectionNominates.path}/${nominateId}`,
        },
      },
    },
  },
  Admins: {
    path: "admins",
    getDocPath: (adminId: AdminId): string => `${FirestorePaths.Admins.path}/${adminId}`,
  },
  AdminInvites: {
    path: "admin-invites",
    getDocPath: (inviteId: AdminInviteId): string => `${FirestorePaths.AdminInvites.path}/${inviteId}`,
  },
  AppConfigs: {
    path: "app-configs",
    getDocPath: (configId: string): string => `${FirestorePaths.AppConfigs.path}/${configId}`,
  },
  FeatureFlags: {
    path: "feature-flags",
    getDocPath: (flagId: string): string => `${FirestorePaths.FeatureFlags.path}/${flagId}`,

    AllowedUsers: {
      path: "allowed-users",
      getPath: (flagId: string): string => `${FirestorePaths.FeatureFlags.path}/${flagId}/${FirestorePaths.FeatureFlags.AllowedUsers.path}`,
      getDocPath: (flagId: string, userId: UserId): string => `${FirestorePaths.FeatureFlags.path}/${flagId}/${FirestorePaths.FeatureFlags.AllowedUsers.path}/${userId}`,
    },
  },
  AllowedDomains: {
    path: "allowed-domains",
    getDocPath: (domainId: AllowedDomainId): string => `${FirestorePaths.AllowedDomains.path}/${domainId}`,
  },
  RecommendedUsers: {
    path: "recommended-users",
    getDocPath: (userId: UserId): string => `${FirestorePaths.RecommendedUsers.path}/${userId}`,
  },
  Brands: {
    path: "brands",
    getDocPath: (brandId: BrandId): string => `${FirestorePaths.Brands.path}/${brandId}`,
  },
  CallPushes: {
    path: "call-pushes",
    getDocPath: (callPushId: CallPushId): string => `${FirestorePaths.CallPushes.path}/${callPushId}`,
  },
  CoinPacks: {
    path: "coin-packs",
    getDocPath: (coinPackId: CoinPackId): string => `${FirestorePaths.CoinPacks.path}/${coinPackId}`,
  },
  DefaultLooks: {
    path: "default-looks",
    getDocPath: (lookId: DefaultLookId): string => `${FirestorePaths.DefaultLooks.path}/${lookId}`,
  },
  InitialLooks: {
    path: "initial-looks",
    getDocPath: (itemId: ItemId): string => `${FirestorePaths.InitialLooks.path}/${itemId}`,
  },
  Migrations: {
    path: "migrations",
    getDocPath: (migrationId: string): string => `${FirestorePaths.Migrations.path}/${migrationId}`,
  },
  FriendCodes: {
    path: "friend-codes",
    getDocPath: (friendCode: FriendCode): string => `${FirestorePaths.FriendCodes.path}/${friendCode}`,
  },
  GlobalNgWords: {
    path: "global-ng-words",
    getDocPath: (ngWordId: GlobalNgWordId): string => `${FirestorePaths.GlobalNgWords.path}/${ngWordId}`,
  },
  Invites: {
    path: "invites",
    getDocPath: (inviteKey: InviteKey): string => `${FirestorePaths.Invites.path}/${inviteKey}`,
  },
  Items: {
    path: "items",
    getDocPath: (itemId: ItemId): string => `${FirestorePaths.Items.path}/${itemId}`,
    Distributions: {
      path: "item-distributions",
      getPath: (itemId: ItemId): string => `${FirestorePaths.Items.path}/${itemId}/${FirestorePaths.Items.Distributions.path}`,
      getDocPath: (itemId: ItemId, distributionId: ItemDistributionId): string => `${FirestorePaths.Items.path}/${itemId}/${FirestorePaths.Items.Distributions.path}/${distributionId}`,
    },
  },
  LiveHistories: {
    path: "live-histories",
    getDocPath: (liveId: LiveId): string => `${FirestorePaths.LiveHistories.path}/${liveId}`,

    LivePowerHistories: {
      path: "live-power-histories",
      getPath: (liveId: LiveId): string => `${FirestorePaths.LiveHistories.path}/${liveId}/${FirestorePaths.LiveHistories.LivePowerHistories.path}`,
      getDocPath: (liveId: LiveId, powerId: LivePowerId): string => `${FirestorePaths.LiveHistories.path}/${liveId}/${FirestorePaths.LiveHistories.LivePowerHistories.path}/${powerId}`,
    },
  },
  LiveGenres: {
    path: "live-genres",
    getDocPath: (genreId: LiveGenreId): string => `${FirestorePaths.LiveGenres.path}/${genreId}`,
  },
  OgpJobs: {
    path: "ogp-jobs",
    getDocPath: (jobId: string): string => `${FirestorePaths.OgpJobs.path}/${jobId}`,
  },
  Powers: {
    path: "powers",
    getDocPath: (powerId: PowerId): string => `${FirestorePaths.Powers.path}/${powerId}`,
  },
  PredefinedAliases: {
    path: "predefined-aliases",
    getDocPath: (aliasId: PredefinedAliasId): string => `${FirestorePaths.PredefinedAliases.path}/${aliasId}`,
  },
  PredefinedAliasesQualifiers: {
    path: "predefined-aliases-qualifiers",
    getDocPath: (qualifierId: PredefinedAliasQualifierId): string => `${FirestorePaths.PredefinedAliasesQualifiers.path}/${qualifierId}`,
  },
  PredefinedNicknames: {
    path: "predefined-nicknames",
    getDocPath: (nicknameId: PredefinedNicknameId): string => `${FirestorePaths.PredefinedNicknames.path}/${nicknameId}`,
  },
  PushPlanJobs: {
    path: "push-plan-jobs",
    getDocPath: (jobId: string): string => `${FirestorePaths.PushPlanJobs.path}/${jobId}`,
  },
  PushSettings: {
    path: "push-settings",
    getDocPath: (settingId: string): string => `${FirestorePaths.PushSettings.path}/${settingId}`,
  },
  Sales: {
    path: "sales",
    getDocPath: (saleId: SaleId): string => `${FirestorePaths.Sales.path}/${saleId}`,
  },
  Souls: {
    path: "souls",
    getDocPath: (soulId: SoulId): string => `${FirestorePaths.Souls.path}/${soulId}`,
  },

  SpaceBackgrounds: {
    path: "space-backgrounds",
    getDocPath: (backgroundId: SpaceBackgroundId): string => `${FirestorePaths.SpaceBackgrounds.path}/${backgroundId}`,
  },
  SpaceBgms: {
    path: "space-bgms",
    getDocPath: (bgmId: SpaceBGMId): string => `${FirestorePaths.SpaceBgms.path}/${bgmId}`,
  },
  Systems: {
    path: "systems",
    getDocPath: (systemId: string): string => `${FirestorePaths.Systems.path}/${systemId}`,
  },
  SystemNotifications: {
    path: "system-notifications",
    getDocPath: (notificationId: SystemNotificationId): string => `${FirestorePaths.SystemNotifications.path}/${notificationId}`,
  },
  ManagedImages: {
    path: "managed-images",
    getDocPath: (imageId: ManagedImageId): string => `${FirestorePaths.ManagedImages.path}/${imageId}`,
  },
  ShopBanners: {
    path: "shop-banners",
  },
  ShopCustomTags: {
    path: "shop-custom-tags",
  },
  ShopTopCompositions: {
    path: "shop-top-compositions",
    getDocPath: (compositionId: string): string => `${FirestorePaths.ShopTopCompositions.path}/${compositionId}`,
  },
  HomeBanners: {
    path: "home-banners",
    getDocPath: (bannerId: HomeBannerId): string => `${FirestorePaths.HomeBanners.path}/${bannerId}`,
  },
  HomePickups: {
    path: "home-pickups",
    getDocPath: (pickupId: HomePickupId): string => `${FirestorePaths.HomePickups.path}/${pickupId}`,
  },
  HomeLivePins: {
    path: "home-live-pins",
    getDocPath: (pinId: HomeLivePinId): string => `${FirestorePaths.HomeLivePins.path}/${pinId}`,
  },
  HomeLiveRankingCaches: {
    path: "home-live-ranking-caches",
    getDocPath: (docId: string): string => `${FirestorePaths.HomeLiveRankingCaches.path}/${docId}`,
  },
  Tasks: {
    path: "tasks",
    getDocPath: (taskId: TaskId): string => `${FirestorePaths.Tasks.path}/${taskId}`,
  },
  TaskResults: {
    path: "task-results",
    getDocPath: (taskResultId: TaskResultId): string => `${FirestorePaths.TaskResults.path}/${taskResultId}`,
  },
  TopicSuggestions: {
    path: "topic-suggestions",
    getDocPath: (topicId: TopicSuggestionId): string => `${FirestorePaths.TopicSuggestions.path}/${topicId}`,
  },
  PushSendJobs: {
    path: "push-send-jobs",
    getDocPath: (jobId: string): string => `${FirestorePaths.PushSendJobs.path}/${jobId}`,
  },
  UserSystemNotificationCheckStatuses: {
    path: "user-system-notification-check-statuses",
    getDocPath: (userId: UserId): string => `${FirestorePaths.UserSystemNotificationCheckStatuses.path}/${userId}`,
  },
  UserPrivates: {
    path: "user-privates",
    getDocPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}`,
    CoinPackPurchaseCounts: {
      path: "coin-pack-purchase-counts",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.CoinPackPurchaseCounts.path}`,
      getDocPath: (userId: UserId, coinPackId: CoinPackId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.CoinPackPurchaseCounts.path}/${coinPackId}`,
    },
    UserSettings: {
      path: "user-settings",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserSettings.path}`,
      getDocPath: (userId: UserId, targetUserId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserSettings.path}/${targetUserId}`,
    },
    UserInventory: {
      path: "user-inventories",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserInventory.path}`,
      getDocPath: (userId: UserId, itemId: ItemId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserInventory.path}/${itemId}`,
    },
    CoinTransactions: {
      path: "coin-transactions",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.CoinTransactions.path}`,
      getDocPath: (userId: UserId, transactionId: string): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.CoinTransactions.path}/${transactionId}`,
    },
    SubscriptionCoinGrants: {
      path: "subscription-coin-grants",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.SubscriptionCoinGrants.path}`,
      getDocPath: (userId: UserId, grantId: string): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.SubscriptionCoinGrants.path}/${grantId}`,
    },
    SubscriptionItemGrants: {
      path: "subscription-item-grants",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.SubscriptionItemGrants.path}`,
      getDocPath: (userId: UserId, grantId: string): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.SubscriptionItemGrants.path}/${grantId}`,
    },
    StoryTimeline: {
      path: "story-timeline",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StoryTimeline.path}`,
      getDocPath: (userId: UserId, followeeId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StoryTimeline.path}/${followeeId}`,
    },
    UserFavorites: {
      path: "user-favorites",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserFavorites.path}`,
      getDocPath: (userId: UserId, entryId: string): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserFavorites.path}/${entryId}`,
    },
    VoiceTimeline: {
      path: "user-voice-timeline",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.VoiceTimeline.path}`,
      getDocPath: (userId: UserId, entryId: string): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.VoiceTimeline.path}/${entryId}`,
    },
    UserActivities: {
      path: "user-activities",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserActivities.path}`,
      getDocPath: (userId: UserId, activityId: string): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserActivities.path}/${activityId}`,
    },
    UserDevices: {
      path: "user-devices",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserDevices.path}`,
      getDocPath: (userId: UserId, deviceId: DeviceId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.UserDevices.path}/${deviceId}`,
    },
    StampCardStates: {
      path: "stamp-card-states",
      getPath: (userId: UserId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}`,
      getDocPath: (userId: UserId, cardId: StampCardId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}`,

      StampMissionProgresses: {
        path: "stamp-mission-progresses",
        getPath: (userId: UserId, cardId: StampCardId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}/${FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.path}`,
        getDocPath: (userId: UserId, cardId: StampCardId, missionId: StampMissionId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}/${FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.path}/${missionId}`,

        StampMissionDailyProgresses: {
          path: "stamp-mission-daily-progresses",
          getPath: (userId: UserId, cardId: StampCardId, missionId: StampMissionId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}/${FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.path}/${missionId}/${FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.StampMissionDailyProgresses.path}`,
          getDocPath: (userId: UserId, cardId: StampCardId, missionId: StampMissionId, dayKey: string): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}/${FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.path}/${missionId}/${FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.StampMissionDailyProgresses.path}/${dayKey}`,
        },
      },

      StampLanes: {
        path: "stamp-lanes",
        getPath: (userId: UserId, cardId: StampCardId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}/${FirestorePaths.UserPrivates.StampCardStates.StampLanes.path}`,

        StampRewardClaims: {
          path: "stamp-reward-claims",
          getPath: (userId: UserId, cardId: StampCardId, laneId: StampLaneId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}/${FirestorePaths.UserPrivates.StampCardStates.StampLanes.path}/${laneId}/${FirestorePaths.UserPrivates.StampCardStates.StampLanes.StampRewardClaims.path}`,
          getDocPath: (userId: UserId, cardId: StampCardId, laneId: StampLaneId, rewardId: StampLaneRewardId): string => `${FirestorePaths.UserPrivates.path}/${userId}/${FirestorePaths.UserPrivates.StampCardStates.path}/${cardId}/${FirestorePaths.UserPrivates.StampCardStates.StampLanes.path}/${laneId}/${FirestorePaths.UserPrivates.StampCardStates.StampLanes.StampRewardClaims.path}/${rewardId}`,
        },
      },
    },
  },
  UserSecrets: {
    path: "user-secrets",
    getDocPath: (userId: string): string => `${FirestorePaths.UserSecrets.path}/${userId}`,
  },
  ViolationReports: {
    path: "violation-reports",
    getDocPath: (reportId: ViolationReportId): string => `${FirestorePaths.ViolationReports.path}/${reportId}`,
  },
  VrmNgItems: {
    path: "vrm-ng-items",
    getDocPath: (itemId: string): string => `${FirestorePaths.VrmNgItems.path}/${itemId}`,
  },
  BulkDeliveryMasters: {
    path: "bulk-delivery-masters",
    getDocPath: (deliveryId: string): string => `${FirestorePaths.BulkDeliveryMasters.path}/${deliveryId}`,

    TargetChunks: {
      path: "bulk-delivery-target-chunks",
      getPath: (deliveryId: string): string => `${FirestorePaths.BulkDeliveryMasters.path}/${deliveryId}/${FirestorePaths.BulkDeliveryMasters.TargetChunks.path}`,
      getDocPath: (deliveryId: string, chunkId: string): string => `${FirestorePaths.BulkDeliveryMasters.path}/${deliveryId}/${FirestorePaths.BulkDeliveryMasters.TargetChunks.path}/${chunkId}`,
    },
  },
  WelcomeDeliveryMasters: {
    path: "welcome-delivery-masters",
    getDocPath: (masterId: WelcomeDeliveryMasterId): string => `${FirestorePaths.WelcomeDeliveryMasters.path}/${masterId}`,

    DeliveredUsers: {
      path: "welcome-delivered-users",
      getPath: (masterId: WelcomeDeliveryMasterId): string => `${FirestorePaths.WelcomeDeliveryMasters.path}/${masterId}/${FirestorePaths.WelcomeDeliveryMasters.DeliveredUsers.path}`,
      getDocPath: (masterId: WelcomeDeliveryMasterId, userId: string): string => `${FirestorePaths.WelcomeDeliveryMasters.path}/${masterId}/${FirestorePaths.WelcomeDeliveryMasters.DeliveredUsers.path}/${userId}`,
    },
  },
  StampCards: {
    path: "stamp-cards",
    getDocPath: (cardId: StampCardId): string => `${FirestorePaths.StampCards.path}/${cardId}`,

    StampLanes: {
      path: "stamp-lanes",
      getPath: (cardId: StampCardId): string => `${FirestorePaths.StampCards.path}/${cardId}/${FirestorePaths.StampCards.StampLanes.path}`,
      getDocPath: (cardId: StampCardId, laneId: StampLaneId): string => `${FirestorePaths.StampCards.path}/${cardId}/${FirestorePaths.StampCards.StampLanes.path}/${laneId}`,

      StampLaneRewards: {
        path: "stamp-lane-rewards",
        getPath: (cardId: StampCardId, laneId: StampLaneId): string => `${FirestorePaths.StampCards.path}/${cardId}/${FirestorePaths.StampCards.StampLanes.path}/${laneId}/${FirestorePaths.StampCards.StampLanes.StampLaneRewards.path}`,
        getDocPath: (cardId: StampCardId, laneId: StampLaneId, rewardId: StampLaneRewardId): string => `${FirestorePaths.StampCards.path}/${cardId}/${FirestorePaths.StampCards.StampLanes.path}/${laneId}/${FirestorePaths.StampCards.StampLanes.StampLaneRewards.path}/${rewardId}`,
      },
    },

    StampMissions: {
      path: "stamp-missions",
      getPath: (cardId: StampCardId): string => `${FirestorePaths.StampCards.path}/${cardId}/${FirestorePaths.StampCards.StampMissions.path}`,
      getDocPath: (cardId: StampCardId, missionId: StampMissionId): string => `${FirestorePaths.StampCards.path}/${cardId}/${FirestorePaths.StampCards.StampMissions.path}/${missionId}`,
    },
  },
  SubscriptionHistories: {
    path: "subscription-histories",
    getDocPath: (historyId: SubscriptionHistoryId): string => `${FirestorePaths.SubscriptionHistories.path}/${historyId}`,
  },
  SubscriptionPlans: {
    path: "subscription-plans",
    getDocPath: (planId: SubscriptionPlanId): string => `${FirestorePaths.SubscriptionPlans.path}/${planId}`,
  },
  SubscriptionProducts: {
    path: "subscription-products",
    getDocPath: (productId: SubscriptionProductId): string => `${FirestorePaths.SubscriptionProducts.path}/${productId}`,
  },
  Subscriptions: {
    path: "subscriptions",
    getDocPath: (contractId: SubscriptionId): string => `${FirestorePaths.Subscriptions.path}/${contractId}`,
  },
  PinnedStoryUsers: {
    path: "pinned-story-users",
    getDocPath: (pinnedStoryUserId: PinnedStoryUserId): string => `${FirestorePaths.PinnedStoryUsers.path}/${pinnedStoryUserId}`,
  },
  SubscriptionItemGrantMasters: {
    path: "subscription-item-grant-masters",
    getDocPath: (masterId: SubscriptionItemGrantMasterId): string => `${FirestorePaths.SubscriptionItemGrantMasters.path}/${masterId}`,

    DistributionChunks: {
      path: "subscription-item-grant-distribution-chunks",
      getPath: (masterId: SubscriptionItemGrantMasterId): string => `${FirestorePaths.SubscriptionItemGrantMasters.path}/${masterId}/${FirestorePaths.SubscriptionItemGrantMasters.DistributionChunks.path}`,
      getDocPath: (masterId: SubscriptionItemGrantMasterId, chunkId: string): string => `${FirestorePaths.SubscriptionItemGrantMasters.path}/${masterId}/${FirestorePaths.SubscriptionItemGrantMasters.DistributionChunks.path}/${chunkId}`,
    },
  },
  AdminOperations: {
    path: "admin-operations",
    getDocPath: (operationId: AdminOperationId): string => `${FirestorePaths.AdminOperations.path}/${operationId}`,
  },
  ManageConfigs: {
    path: "manage-configs",
    getDocPath: (configId: string): string => `${FirestorePaths.ManageConfigs.path}/${configId}`,
  },
  LivePoints: {
    path: "live-points",
    getDocPath: (livePointId: LivePointId): string => `${FirestorePaths.LivePoints.path}/${livePointId}`,
  },
} as const
